export { RequestMethods } from './requestMethods';
export { RequestStatuses } from './requestStatuses';
export { authExcludedEndpoints } from './authExcludedEndpoints';

export const baseUrl: string = import.meta.env.VITE_BASE_API_URL || '';
